<template>
  <div class="container-fluid">
    <div class="row mt-3">
      <div class="col-md-8 col-lg-6 mx-auto">
        <div class="card">
          <div class="card-header d-flex align-items-center justify-content-between">
            <h5 class="mb-0">
              <vue-feather type="layers" class="me-1"></vue-feather> Nuevo programa
            </h5>
            <button class="btn btn-outline-secondary btn-sm" @click="$router.back()">
              <vue-feather type="arrow-left" size="14" class="me-1"></vue-feather> Regresar
            </button>
          </div>

          <div class="card-body">

            <div v-if="successMsg" class="alert alert-success d-flex align-items-center">
              <vue-feather type="check-circle" size="16" class="me-2"></vue-feather> {{ successMsg }}
            </div>
            <div v-if="errorMsg" class="alert alert-danger d-flex align-items-center">
              <vue-feather type="alert-circle" size="16" class="me-2"></vue-feather> {{ errorMsg }}
            </div>

            <form @submit.prevent="guardar" novalidate>

              <div class="mb-3">
                <label class="form-label">Nombre <span class="text-danger">*</span></label>
                <input
                  v-model="form.nombre"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.nombre }"
                  placeholder="Nombre del programa"
                />
                <div class="invalid-feedback">Campo requerido.</div>
              </div>

              <div class="mb-3">
                <label class="form-label">Tipo <span class="text-danger">*</span></label>
                <select v-model="form.tipo" class="form-select" :class="{ 'is-invalid': errors.tipo }" :disabled="loadingCatalogo">
                  <option :value="null" disabled>{{ loadingCatalogo ? 'Cargando…' : 'Selecciona un tipo' }}</option>
                  <option v-for="t in catalogoTipos" :key="t.id" :value="t.id">{{ t.nombre }}</option>
                </select>
                <div class="invalid-feedback">Selecciona un tipo.</div>
              </div>

              <div class="mb-3">
                <label class="form-label">Población objetivo <span class="text-danger">*</span></label>
                <input
                  v-model="form.poblacion_objetivo"
                  type="text"
                  class="form-control"
                  :class="{ 'is-invalid': errors.poblacion_objetivo }"
                  placeholder="Ej. MiPyMEs, Productores, etc."
                />
                <div class="invalid-feedback">Campo requerido.</div>
              </div>

              <div class="mb-3">
                <label class="form-label">Fecha de creación <span class="text-danger">*</span></label>
                <input
                  v-model="form.fecha_creacion"
                  type="date"
                  class="form-control"
                  :class="{ 'is-invalid': errors.fecha_creacion }"
                />
                <div class="invalid-feedback">Campo requerido.</div>
              </div>

              <div class="d-flex justify-content-end gap-2 mt-4">
                <button type="button" class="btn btn-outline-secondary" @click="$router.back()">Cancelar</button>
                <button type="submit" class="btn btn-primary" :disabled="guardando">
                  <span v-if="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span> Guardando…
                  </span>
                  <span v-else>
                    <vue-feather type="save" size="14" class="me-1"></vue-feather> Guardar programa
                  </span>
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/axios";
import authService from "@/services/authService";

export default {
  name: "NuevoPrograma",

  data() {
    return {
      form: {
        nombre: "",
        tipo: null,
        poblacion_objetivo: "",
        fecha_creacion: "",
      },
      errors: {},
      guardando: false,
      loadingCatalogo: false,
      catalogoTipos: [],
      successMsg: null,
      errorMsg: null,
    };
  },

  created() {
    this.fetchCatalogo();
  },

  methods: {
    async fetchCatalogo() {
      this.loadingCatalogo = true;
      try {
        const { data } = await api.get("catalogos");
        this.catalogoTipos = data.tipos_oportunidad ?? [];
      } catch {
        // el select permanece vacío; el usuario verá el mensaje de carga
      } finally {
        this.loadingCatalogo = false;
      }
    },
    validar() {
      const e = {};
      if (!this.form.nombre.trim()) e.nombre = true;
      if (!this.form.tipo) e.tipo = true;
      if (!this.form.poblacion_objetivo.trim()) e.poblacion_objetivo = true;
      if (!this.form.fecha_creacion) e.fecha_creacion = true;
      this.errors = e;
      return Object.keys(e).length === 0;
    },

    async guardar() {
      if (!this.validar()) return;
      this.guardando = true;
      this.successMsg = null;
      this.errorMsg = null;
      try {
        const ud = authService.getUserData();
        const userId = ud?.id ?? ud?.pk;
        const payload = {
          nombre:            this.form.nombre,
          tipo_id:           this.form.tipo,
          poblacion_objetivo: this.form.poblacion_objetivo,
          fecha_creacion:    this.form.fecha_creacion.replace(/-/g, "/"),
          user:              userId,
        };
        const { data } = await api.post("programas/", payload);
        this.successMsg = `Programa "${data.nombre}" registrado correctamente.`;
        this.form = { nombre: "", tipo: null, poblacion_objetivo: "", fecha_creacion: "" };
        this.errors = {};
        // Redirigir a configuración después de un momento
        setTimeout(() => this.$router.push({ name: "evaluacionesConfiguracion" }), 1500);
      } catch (err) {
        this.errorMsg =
          err.response?.data?.detail ??
          JSON.stringify(err.response?.data) ??
          "Error al guardar el programa.";
      } finally {
        this.guardando = false;
      }
    },
  },
};
</script>
